export enum ELanguage {
  English = 'en',
  Thai = 'th'
}
